import React from 'react';
import { LinkData } from '../types';

interface Props {
  config: Record<string, any>;
  links: LinkData[];
}

export const SidebarCardStack: React.FC<Props> = ({ config, links }) => {
  // Use correct field names from types.ts
  const {
    moduleHeading = 'Relevant Blogs',
    maxCards = 4,
    showImage = true,
    imageSize = 'small',
    imagePosition = 'left',
    showCategory = false,
    cardBackground = 'white',
  } = config;

  // Get background color
  const getBgColor = () => {
    switch (cardBackground) {
      case 'gray':
        return '#f8fafc';
      case 'transparent':
        return 'transparent';
      default:
        return '#ffffff';
    }
  };

  // Get image dimensions based on imageSize
  const getImageDimensions = () => {
    switch (imageSize) {
      case 'medium':
        return { width: '80px', height: '60px' };
      case 'thumbnail':
        return { width: '50px', height: '38px' };
      default:
        return { width: '60px', height: '45px' }; // small
    }
  };

  const imgDimensions = getImageDimensions();

  return (
    <div
      style={{
        background: getBgColor(),
        padding: '1rem',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        maxWidth: '300px',
      }}
    >
      <h3 style={{ fontSize: '1rem', margin: '0 0 0.75rem 0', color: '#1e3a5f', fontWeight: 600 }}>{moduleHeading}</h3>
      {links.slice(0, maxCards).map((link, i) => (
        <div
          key={i}
          style={{
            display: 'flex',
            flexDirection: imagePosition === 'top' ? 'column' : 'row',
            gap: '0.75rem',
            padding: '0.625rem 0',
            borderTop: i > 0 ? '1px solid #e5e7eb' : 'none',
          }}
        >
          {showImage && (
            <div
              style={{
                width: imagePosition === 'top' ? '100%' : imgDimensions.width,
                height: imagePosition === 'top' ? '80px' : imgDimensions.height,
                background: link.image ? `url(${link.image}) center/cover` : '#f3f4f6',
                borderRadius: '4px',
                flexShrink: 0,
                overflow: 'hidden',
              }}
            >
              {link.image && (
                <img
                  src={link.image}
                  alt={link.title || ''}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              )}
            </div>
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            {showCategory && link.category && (
              <span
                style={{
                  fontSize: '0.7rem',
                  color: '#2db77a',
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  display: 'block',
                  marginBottom: '0.25rem',
                }}
              >
                {link.category}
              </span>
            )}
            <a
              href={link.url}
              style={{
                color: '#1e3a5f',
                textDecoration: 'none',
                fontSize: '0.85rem',
                fontWeight: 500,
                display: 'block',
                lineHeight: 1.3,
              }}
            >
              {(link.title || link.anchorText || link.url).substring(0, 50)}
              {(link.title || '').length > 50 ? '...' : ''}
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};
